import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { SalesDiscount } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SalesDiscountService extends TmsWebBaseEditService<SalesDiscount, SalesDiscount> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('SalesDiscount', $localize`Sales Discount`, httpService, notificationService);
  }
}
